import Box from "@mui/material/Box";
import dynamic from "next/dynamic";
import useGlobalSettings from "@components/_hooks/useGlobalSettings";

const HomeGalleryImages = dynamic(() => import("../HomeComponent/HomeGalleryImages"));

export default function RenderGalleryImages({ template_page_settings, page, gallery_images }) {
	const { getPageSetting } = useGlobalSettings(template_page_settings);
	const show_gallery_images = getPageSetting(template_page_settings, page, 'show_gallery_images', 'no');
	if (show_gallery_images == 'yes') {
		return (
			<Box className="my-3">
				<HomeGalleryImages images={gallery_images?.data || []} />
			</Box>
		)
	}
}